import Vue from 'vue';
import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll);
